module.exports = {
  main_title: 'マイナンバーカードを、スマートに。',
  main_subtitle: 'カギ、ハンコ、身分証が一つのアプリになりました。',
  main_btn: '今すぐ始める',
  about_title: 'デジタルIDアプリ <span>x</span>ID とは',
  about_desc: `複雑なパスワードをいくつも覚えたり、 <br> 何度も何度も個人情報を入力をしたり、 <br> 本人確認のたびに身分証の写真データを提出したり…
    <br><br> <span>x</span>ID(クロスID)は、そんなデジタル世界に溢れる “<span>面倒くさい</span>” を <br> 解消するために誕生した「<span>デジタルIDアプリ</span>」です。
    <br><br> 公的個人認証サービスを用いて <br> マイナンバーカードを連携した独自のIDを生成することで、 <br> デジタル世界の <span>利便性・本人性・安全性</span> を同時に向上させます。`,
  about_install_btn: 'インストール',
  about_corporate_services_btn: '法人向けAPI',
  features_title: 'FEATURES',
  features_1_title: '様々なサービスに <br> パスワードレスでログイン',
  features_1_desc: 'xIDは2種類のPINコードの「知識」と、デジタルデバイスの「所有」を組み合せた2要素認証を採用しています。もう複雑なパスワードを覚える必要はありません。',
  features_2_title: 'マイナンバーカードで認証 <br> 本人確認はタッチでらくらく',
  features_2_desc: '初回登録時、マイナンバーカードをスマホにタッチして本人確認を実施すれば、それ以降xID導入サービスでの本人確認が不要に。',
  features_3_title: '名前に生年月日、住所に性別 <br> 面倒な情報入力は不要です',
  features_3_desc: 'マイナンバーカードから取得された名前、生年月日、住所や性別は、ユーザーの同意がなされるとサービス事業者側に連携されます。面倒な情報入力はもう不要です。',
  features_5_title: '個人情報はユーザーの <br> 同意に基づいてのみ提供します',
  features_5_desc: '個人情報は全て暗号化して保存されています。復号できるのはユーザー自身と、ユーザーがアクセスを許可した事業者のみです。xID運営者であっても、ユーザーの個人情報を確認することは技術上できません。',
  step_title: 'HOW <span>x</span>ID WORKS',
  step_subtitle: '初回登録は数分で完結  今日から始めるxID',
  step_1_title: 'xIDアプリをインストール',
  step_1_desc: '以下からxIDアプリをインストールしてください。',
  step_2_title: 'マイナンバーカードで本人確認',
  step_2_desc: '4桁のPIN1、6桁のPIN2を設定した後、お手持ちの <br> スマホにマイナンバーカードをかざして、マイナンバーカードの署名用パスワード（6～16桁の数字・英大文字）を入力するだけ。 <br> 面倒な住所情報などの入力は一切必要ありません。',
  step_3_title: 'xID導入サービスでログイン/電子署名',
  step_3_desc: '初回設定完了後、すぐにxIDと連携するサービスをご利用いただくことが可能です。 <br> ログイン時や署名時に、設定したPIN1ないしはPIN2の入力がリクエストされます。(生体認証も利用可）',
  service_title: '<span>x</span>ID導入サービス',
  service_subtitle: 'xIDはまだ生まれたばかり  これから様々な業界・サービスで導入予定です',
  service_1_desc: '完全無料の電子契約サービス',
  service_2_desc: '電子申請プラットフォーム',
  service_3_desc: 'LoGoフォーム電子申請',
  service_4_desc: 'メンタルヘルスサービス',
  service_6_desc:'完全非対面の賃貸サービス',
  business_title: '<span>x</span>ID API',
  business_desc: '法人向けに提供されているxID APIは、電子認証API、電子署名API、個人情報確認API、 <br> マイナンバー要求APIの4つによって構成されています。 <br> 自社サービスに組みこむことで、本人確認や開発コストの削減、情報漏洩やパスワード漏洩による <br> セキュリティリスクの低下、利用者の利便性向上が期待可能です。',
  business_1_title: '様々なコスト削減が可能',
  business_1_desc: 'eKYCで、本人確認にかかるコスト削減が可能。自社でのパスワード管理が不要になるため、セキュリティ対策費用も抑制できます。',
  business_2_title: '高度なセキュリティレベルを実現',
  business_2_desc: '多要素認証を活用することで、近年増加するハッキング被害や情報漏えいからユーザーを守ります。',
  business_3_title: '登録フローを大幅に短縮化',
  business_3_desc: '名前・住所などの個人情報の入力は不要。 <br> クイックな本人確認や登録プロセスで、 <br> ユーザーの利便性を大きく向上させます。',
  business_btn: 'お問い合わせ',
  partner_title: '<span>x</span>IDパートナー',
  partner_subtitle: 'FinTechやGovTechを中心としたあらゆる“xTech”分野で、 <br> xIDを活用した民間・自治体向けのサービスを開発・提供しています。',
  trust_bank_name: '株式会社トラストバンク',
  scala_name: '株式会社スカラパートナーズ',
  fujisoft_name:'富士ソフト株式会社',
  votefor_name: '株式会社VOTE FOR',
  layerx_name: '株式会社LayerX',
  seven_bank_name: '株式会社セブン銀行',
  monstar_lab_name: '株式会社モンスターラボ',
  faq_title: 'FAQ',
  faq_desc: 'xIDの利用にあたって、不明点やエラーが発生した場合は、こちらのFAQ（よくある質問集）からご確認ください。',
  faq_btn: 'FAQを見る',
  contact_title: 'お問い合わせ',
  contact_desc: '貴社サービスへのxID導入や、新規事業開発のご相談等、ご協業に関するお問い合わせからはこちらからお願いいたします。詳しい機能や実装方法などについても、お気軽にお問い合わせください。',
  contact_btn: 'お問い合わせ',
};
